export class Address {
  country_iso: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  post_code: string;
}
